import {Grid, Stack} from '@mui/material'
import FilterControls from './FilterControls'
import EditControls from './EditControls'
import EnhancementsReportFilter, {EnhancementFilterActions, EnhancementFilterData} from './EnhancementsReportFilter'

interface EnhancementsReportHeaderProps extends EnhancementFilterActions, EnhancementFilterData {
  readonly onFilterClick: () => void;
  readonly onRefreshClick: () => void;
  readonly showFilters: boolean;
  readonly filterDataTestId?: string;
  readonly refreshDataTestId?: string;
  readonly isEditMode?: boolean;
  readonly onToggleEditMode?: () => void;
  readonly onResetSections?: () => void;
  readonly editDataTestId?: string;
  readonly resetDataTestId?: string;
  readonly isLoading?: boolean;
}



function EnhancementsReportHeader({
                                    onFilterClick,
                                    onRefreshClick,
                                    showFilters,
                                    selectedDepartments,
                                    setSelectedDepartments,
                                    selectedTeams,
                                    setSelectedTeams,
                                    fromPayPeriod,
                                    toPayPeriod,
                                    handleFromPayPeriodChange,
                                    handleToPayPeriodChange,
                                    departmentsList,
                                    teamList,
                                    handleSubmit,
                                    filterDataTestId = 'EnhancementReporting-Filter-Btn',
                                    refreshDataTestId = 'EnhancementReporting-Refresh-Btn',
                                    editDataTestId = 'EnhancementReporting-Edit-Btn',
                                    resetDataTestId = 'EnhancementReporting-Reset-Btn',
                                    isEditMode = false,
                                    onToggleEditMode,
                                    onResetSections,
  isLoading = false
}: EnhancementsReportHeaderProps) {
  
  return (
    <>
      <Grid container alignItems="center" justifyContent="space-between">
        <Grid item xs={3} />
        
        <Grid item xs={5} display="flex" justifyContent="center" />

        <Grid item xs={4} display="flex" justifyContent="flex-end">
          <Stack direction="row" spacing={2} alignItems="center">
            {!isEditMode && (
              <FilterControls
                onFilterClick={onFilterClick}
                onRefreshClick={onRefreshClick}
                filterDataTestId={filterDataTestId}
                refreshDataTestId={refreshDataTestId}
              />
            )}
            {onToggleEditMode && (
              <EditControls
                isEditMode={isEditMode}
                onToggleEditMode={onToggleEditMode}
                onResetSections={onResetSections}
                editDataTestId={editDataTestId}
                resetDataTestId={resetDataTestId}
              />
            )}
          </Stack>
        </Grid>
      </Grid>


      <div style={{display: showFilters && !isEditMode ? 'block' : 'none'}}>
        <EnhancementsReportFilter
          selectedDepartments={selectedDepartments}
          setSelectedDepartments={setSelectedDepartments}
          selectedTeams={selectedTeams}
          setSelectedTeams={setSelectedTeams}
          fromPayPeriod={fromPayPeriod}
          toPayPeriod={toPayPeriod}
          handleFromPayPeriodChange={handleFromPayPeriodChange}
          handleToPayPeriodChange={handleToPayPeriodChange}
          departmentsList={departmentsList}
          teamList={teamList}
          handleSubmit={handleSubmit}
          showSearchButton={false}
        />
      </div>
    </>
  )
}


export default EnhancementsReportHeader